import script from "./AdminSales.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSales.vue?vue&type=script&setup=true&lang=js"

import "./AdminSales.vue?vue&type=style&index=0&id=e729a63e&scoped=true&lang=css"
import "./AdminSales.vue?vue&type=style&index=1&id=e729a63e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e729a63e"]])

export default __exports__